<mat-toolbar class="theme-empty-header">
  <mat-toolbar-row>
    <div class="header-start-content"></div>
    <span class="header-spacer"></span>
    <img src="../../../assets/images/logo-renault.png" alt="Logo" class="header-image">
  </mat-toolbar-row>
</mat-toolbar>
